<script setup lang="ts">
const { denyAll, acceptAll, hasUserMadeChoice, isConsentExpired } =
  useCookieConsent()

const showBanner = ref(!hasUserMadeChoice.value || isConsentExpired.value)

watch([hasUserMadeChoice, isConsentExpired], () => {
  showBanner.value = !hasUserMadeChoice.value || isConsentExpired.value
})

function handleAccept() {
  acceptAll()
  showBanner.value = false
}

function handleDeny() {
  denyAll()
  showBanner.value = false
}
</script>

<template>
  <div
    v-if="showBanner"
    class="fixed bottom-0 left-0 right-0 bg-white/85 border-t border-t-gray-200 py-2.5 z-50 w-full"
  >
    <UContainer
      class="flex flex-col md:flex-row items-center gap-4 md:gap-6 relative"
    >
      <p class="text-pretty text-stone-950">
        <strong v-if="isConsentExpired">
          Your cookie preferences have expired. Please review them again.
        </strong>
        We use cookies to make your experience better and more personal. With
        your consent, we use Google Ads and Analytics to understand what you
        love and improve how we show up for you. Click “Accept” to allow all
        cookies, or “Customize” to choose which ones you’d like to allow.
        <!--          <ULink to="/support/cookie-policy" color="neutral"-->
        <!--            >Cookie Policy</ULink-->
        <!--          >-->
      </p>

      <div
        class="flex flex-col-reverse sm:flex-row gap-2.5 w-full md:max-w-[350px]"
      >
        <UButton
          block
          variant="outline"
          @click="handleDeny"
          class="text-nowrap"
        >
          Reject
        </UButton>

        <CookieModal />

        <UButton block @click="handleAccept" class="text-nowrap px-10">
          Accept
        </UButton>
      </div>
    </UContainer>
  </div>
</template>
